import { h } from "preact";
import { Link } from "react-router-dom";

import tracking from "../tracking/tracking";
import { classNames, renderIcon } from "../helpers";

export default function Button({
  children,
  circular,
  filterButton,
  flat,
  text,
  textWhite,
  secondary,
  outlined,
  danger,
  light,
  mint,
  noIndent,
  large,
  small,
  iconFront,
  iconBack,
  noHighlight,
  trackingName,
  trackingParams,
  ...props
}) {
  const classes = noHighlight
    ? ["button", "z-depth-0"]
    : ["waves-effect", "waves-light", "button", "z-depth-0"];

  if (mint) {
    classes.push("button--minted");
  }
  if (small) {
    classes.push("button--small");
  }
  if (large) {
    classes.push("button--large");
  }
  if (light) {
    classes.push("button--light");
  }
  if (noIndent) {
    classes.push("button--noIndent");
  }
  if (outlined) {
    classes.push("button--outlined");
  } else if (danger) {
    classes.push("button--danger");
  } else if (secondary) {
    classes.push("button--secondary");
  } else if (text) {
    classes.push("button--text");
  } else if (textWhite) {
    classes.push("button--text-white");
  } else if (!text && !textWhite) {
    classes.push("button--default");
  }
  if (circular) {
    classes.push("button--circular");
  }
  if (filterButton) {
    classes.push("button--filter-button");
  }
  if (flat) {
    classes.push("button--flat");
  }

  classes.push(props.class);

  let Tag = "button";
  if (props.href) {
    Tag = "a";
    if (!props.sameWindow) {
      props = { target: "_blank", ...props };
    }
  } else if (props.to) {
    Tag = Link;
    props = { ...props, to: props.to };
  }
  let buttonName = Array.isArray(children)
    ? children
        .filter((x) => typeof x === "string")
        .join("")
        .trim()
    : children.toString();
  if (typeof children === "object") {
    buttonName = null;
  }

  function handleClick(event) {
    // If it is an object, it is an icon button and this won't work
    if (buttonName) {
      tracking.track("button.click", {
        name: trackingName || buttonName,
        ...(trackingParams || {}),
      });
    }

    if (props.onClick) {
      props.onClick(event);
    }
  }
  return (
    <Tag {...props} onClick={handleClick} class={classNames(...classes)}>
      {renderIcon(iconFront, "button__frontIcon")}
      <span>{children}</span>
      {renderIcon(iconBack, "button__backIcon")}
    </Tag>
  );
}
